<template>
  <over-layout
    :request="request"
    plat-form=""
    :menuJump="1"
    :hiddenTenant="true"
    :ignoreHelpCenter="true"
    :hiddenUser="true"
    :ignoreStep="true"
    :show-second-menu="true"
    :submenu-key="getSubmenuKey(secondMenuList)"
  >
    <template>
      <div slot="navbar" class="nav-mini-component">
        <!-- 隐私开关 -->
        <PrivacySwitch />
        <!-- 问题反馈 -->
        <qen />
        <!-- 微信小程序码 -->
        <wx-code-popover />
      </div>
    </template>
    <template slot="contentTop">
      <div>
        <!-- 历史导航条 -->
        <tabsView />
        <!-- 面包屑 -->
        <bread-crumb />
        <!-- 版本检测组件（仅生产环境） -->
        <version-checker v-if="$options.components.VersionChecker" />
      </div>
    </template>

  </over-layout>
</template>
<script>
import { mapGetters } from 'vuex'
// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'
import tabsView from './tabsView.vue'
import qen from './qen.vue'
import BreadCrumb from '@/components/OverLayout/components/Breadcrumb.vue'
import PrivacySwitch from '@/components/PrivacySwitch/index.vue'

export default {
  components: {
    tabsView,
    qen,
    BreadCrumb,
    PrivacySwitch,
    // 仅生产环境加载版本检测组件
    ...(process.env.NODE_ENV === 'production' && {
      VersionChecker: () => import('@/components/VersionChecker/index.vue'),
    }),
  },
  provide() {
    return {
      parentLayout: this,
    }
  },
  name: 'Layout',
  data() {
    return {
      request,
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['subMenuList']),
    secondMenuList() {
      return this.subMenuList
    },
  },
  created() {
    this.$store.dispatch('getAreaLinkageProvinceList')
  },
  mounted() {
    this.$store.dispatch('getCityListFn')
    this.$store.dispatch('getRentMallOpenSwitchFn')
    this.$store.dispatch('getLeasePlanCalculateOpenFn')
  },
  methods: {
    getSubmenuKey(list) {
      return list.reduce((total, item) => {
        return total.concat([item.resourceKey])
      }, [])
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/mixin.scss';
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.main-container__content {
  display: flex;
  .main-container__left {
    flex: 1;
  }
}
.user-content {
  display: flex;
  position: relative;
  align-items: center;
  .show-company {
    position: absolute;
    width: 154px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
  }
  ::v-deep .user-box {
    display: flex;
    margin: 0 18px 0 4px;
    color: #606266;
    align-items: center;
    .user-avatar {
      margin: 8px;
      width: 24px;
      line-height: 24px;
      height: 24px;
      border-radius: 50%;
      // background: #C8C9CC;
      color: #fff;
      font-size: 23px;
      text-align: center;
    }
  }
  .el-dropdown-menu {
    width: 100px;
  }
}
::v-deep .user-content .check-city .el-input__inner {
  padding-right: 74px;
  border: none;
  color: transparent;
  background-color: transparent;
}
::v-deep .user-content .el-input__suffix .el-icon-arrow-up {
  width: 70px;
  transform: inherit;
  &:before {
    content: '[公司切换]';
    color: #2e7eff;
    width: 70px;
    display: inline-block;
    line-height: 56px;
  }
}
::v-deep .app-breadcrumb-wrap {
  z-index: auto;
}
.nav-mini-component {
  display: flex;
  flex-direction: row;
  color: #303133;
  font-size: 14px;
}
</style>
